// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ad0cabfa","977":"f6afbc91"}[chunkId] + ".chunk.js";
};